import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { AnimatedList } from 'react-animated-list';
import { Posts } from '../Posts/posts';
// import PostLoading from '../Post/PostLoading';
// import getRandomNumber from '../../util/getRandomNumber';
import {
  fetchPosts,
  selectFilteredPosts,
  setSearchTerm,
  fetchComments,
} from '../../Store/redditSlice';
import './Home.css';


const Home = () => {
  const reddit = useSelector((state) => state.reddit);
  const { error, searchTerm, selectedSubreddit } = reddit;
  const posts = useSelector(selectFilteredPosts);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPosts(selectedSubreddit));
  }, [selectedSubreddit, dispatch]);

  const onToggleComments = (index) => {
    const getComments = (permalink) => {
      dispatch(fetchComments(index, permalink));
    };

    return getComments;
  };

//   if (isLoading) {
//     return (
//       <AnimatedList animation="zoom">
//         {Array(getRandomNumber(3, 10)).fill(<PostLoading />)}
//       </AnimatedList>
//     );
//   }

  if (error) {
    return (
      <div className="error">
        <h2>Failed to load posts.</h2>
        <button
          type="button"
          onClick={() => dispatch(fetchPosts(selectedSubreddit))}
        >
          Try again
        </button>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="error">
        <h2>No posts matching "{searchTerm}"</h2>
        <button type="button" onClick={() => dispatch(setSearchTerm(''))}>
          Go home
        </button>
      </div>
    );
  }

  return (
    <>
      {posts.map((post, index) => (
        <Posts
          key={post.id}
          post={post}
          onToggleComments={onToggleComments(index)}
        />
      ))}
    </>
  );
};

export default Home;
